module.exports = __webpack_public_path__ + "static/fonts/Gotham-Medium.e19c20e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Medium.otf
// module id = HYOa
// module chunks = 1